import { useAsync } from '@flowwai-frontend/shared/common-components'

import { ReSendEmailOTPAPIRequestType } from '../../services/types'

import { useLoginService } from '../services/useLoginService'

const useResendEmailOTPAPI = () => {
   const loginService = useLoginService()

   const {
      mutateAsync: resendEmailOTPAPI,
      apiStatus: resendEmailOTPAPIStatus,
      error: resendEmailOTPAPIError
   } = useAsync<unknown, Error, ReSendEmailOTPAPIRequestType>(
      loginService.resendEmailOTP
   )

   return {
      resendEmailOTPAPI,
      resendEmailOTPAPIStatus,
      resendEmailOTPAPIError
   }
}

export { useResendEmailOTPAPI }
